import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
import store from "../../store";
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() { }

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                "VENTAS PRODUCTO\n",
                "AGRUPADO CATEGORIA\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: ["*", 50, 50, 100],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        {
          text: "Nombre",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
        { text: "Cantidad", border: [true, true, true, true], fontSize: 12 },
        { text: "Precio", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Monto",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "right",
        },
      ],
    ];
    let grandTotal = 0;
    let groupedData = [];
    let total = 0;
    let totalCantidad = 0;
    let mercadosGreenFee = {};
    let orderedData = _.orderBy(
      data,
      ["CategoriaName", "TotalGeneral", "Nombre", "Vendidos"],
      ["asc", "desc", "asc", "desc"]
    );

    let grouper = "";
    orderedData.forEach((venta, index) => {
      if (grouper != venta.CategoriaName) {
        groupedData.push({
          header: true,
          text: venta.CategoriaName,
        });
      }
      groupedData.push(venta);
      if (venta.CategoriaName == "GREEN FEE") {
        let mercadoNombre = "";
        if (venta.MerN && String(venta.MerN).trim()) {
          mercadoNombre = String(venta.MerN).trim();
        } else if (venta.Mer) {
          const mercados =
            store.getters["TarifasStore/getMercadosReserva"] ||
            store.state.TarifasStore?.mercadosReserva ||
            [];
          const mercadoEncontrado = Array.isArray(mercados)
            ? mercados.find((m) => m.id == venta.Mer || m.Id == venta.Mer)
            : null;

          if (
            mercadoEncontrado &&
            (mercadoEncontrado.nm || mercadoEncontrado.nombre || mercadoEncontrado.Nombre)
          ) {
            mercadoNombre = String(
              mercadoEncontrado.nm || mercadoEncontrado.nombre || mercadoEncontrado.Nombre
            ).trim();
          } else {
            mercadoNombre = venta.Tur ? "TURISTA" : "LOCAL";
          }
        } else {
          mercadoNombre = venta.Tur ? "TURISTA" : "LOCAL";
        }

        if (!mercadosGreenFee[mercadoNombre]) {
          mercadosGreenFee[mercadoNombre] = {
            nombre: mercadoNombre,
            total: 0,
            pax: 0,
          };
        }
        mercadosGreenFee[mercadoNombre].total += Number(venta.Total || 0);
        mercadosGreenFee[mercadoNombre].pax += Number(venta.Vendidos || 0);
      }
      total += Number(venta.Total);
      totalCantidad += Number(venta.Vendidos);
      grouper = venta.CategoriaName;

      if (orderedData[index + 1]) {
        if (orderedData[index + 1].CategoriaName != venta.CategoriaName) {
          if (venta.CategoriaName == "GREEN FEE") {
            groupedData.push({
              greenFeeSumatory: true,
              mercados: Object.values(mercadosGreenFee),
            });
          }
          groupedData.push({
            footer: true,
            text: "Total",
            total: total,
            totalCantidad: totalCantidad,
          });
          total = 0;
          totalCantidad = 0;
        }
      } else {
        if (venta.CategoriaName == "GREEN FEE") {
          groupedData.push({
            greenFeeSumatory: true,
            mercados: Object.values(mercadosGreenFee),
          });
        }
        groupedData.push({
          footer: true,
          text: "Total",
          total: total,
          totalCantidad: totalCantidad,
        });
        total = 0;
        totalCantidad = 0;
      }
    });

    groupedData.forEach((venta) => {
      let rowToAdd = [];
      if (!venta.header & !venta.footer && !venta.greenFeeSumatory) {
        rowToAdd = [
          {
            text: venta.Nombre,
            border: [true, false, false, false],
            fontSize: 10,
            alignment: "left",
          },
          {
            text: venta.Vendidos,
            border: [false, false, false, false],
            fontSize: 9,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Precio),
            border: [false, false, false, false],
            fontSize: 9,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            border: [false, false, true, false],
            fontSize: 10,
            alignment: "right",
          },
        ];
        times.push(rowToAdd);
        if (venta.ModificadoresAplicados) {
          const modiArray = Object.entries(venta.ModificadoresAplicados)
          modiArray.forEach((mod) => {
            times.push([
              {
                text: "  -          " + mod[1].Cnt +
                  " " +
                  mod[1].nam +
                  " " +
                  pgsHelper.formatNumber(mod[1].pco.C) + " " +
                  mod[1].pco.M,
                border: [true, false, true, false],
                fontSize: 8,
                colSpan: 4,
              },
            ]);
          })
        }
      }
      if (venta.header) {
        rowToAdd = [
          {
            text: venta.text,
            border: [true, true, true, true],
            fontSize: 12,
            colSpan: 4,
            fillColor: "#CCE3F4",
          },
        ];
        times.push(rowToAdd);
      }
      if (venta.footer) {

        grandTotal += Number(venta.total);
        rowToAdd = [
          {
            text: venta.text,
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: venta.totalCantidad,
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "",
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
            fillColor: "#DCDCDC",
          },
        ];
        times.push(rowToAdd);
      }
      if (venta.greenFeeSumatory) {
        const mercados = venta.mercados || Object.values(mercadosGreenFee);
        mercados.forEach((mercado) => {
          rowToAdd = [
            {
              text: mercado.nombre,
              border: [true, true, true, true],
              fontSize: 10,
              fillColor: "#DCDCDC",
            },
            {
              text: pgsHelper.formatNumber(mercado.pax),
              border: [true, true, true, true],
              fontSize: 10,
              fillColor: "#DCDCDC",
            },
            {
              text: "",
              border: [true, true, true, true],
              fontSize: 10,
              fillColor: "#DCDCDC",
            },
            {
              text: "$" + pgsHelper.formatNumber(mercado.total),
              border: [true, true, true, true],
              fontSize: 10,
              alignment: "right",
              fillColor: "#DCDCDC",
            },
          ];
          times.push(rowToAdd);
        });
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      table: {
        body: times,
      },
    };

    times.push([
      {
        text: "TOTAL GENERAL",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "$" + pgsHelper.formatNumber(grandTotal),
        bold: true,
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "right",
        fillColor: "#DCDCDC",
      },
    ]);

    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
